import React from 'react';
import * as ResourceApi from 'api/resources';
import IndexedSubSectionWrapper from "hoc/IndexedSubSectionWrapper";
import {createButtonSectionFactory} from "hoc/CreateButtonSection";
import {isNoU} from "utils/DBUtils";
import {FBCommentQuestionToolTip} from 'components/break/tooltips/breaks-steps-section-tool-tips';
import {
  ListicleAddTrackingToVotingButtonsToolTip,
  ListicleAllowVotingToolTip,
  ListicleDefaultAllowVotingToolTip,
  ListicleDefaultDownvoteButtonIconToolTip,
  ListicleDefaultDownvoteButtonTextToolTip,
  ListicleDefaultShowNumbersToolTip,
  ListicleDefaultUpvoteButtonIconToolTip,
  ListicleDefaultUpvoteButtonTextToolTip,
  ListicleDownvoteButtonTextToolTip,
  ListicleEmbedToolTip,
  ListicleHeaderImageToolTip,
  ListicleHeadlineToolTip,
  ListicleImageScalingToolTip,
  ListicleImageToolTip,
  ListicleIntroToolTip,
  ListicleItemBlockquoteToolTip,
  ListicleItemBodyCopyToolTip,
  ListicleItemSocialShareImageToolTip,
  ListicleItemSubheadToolTip,
  ListicleShowNumbersToolTip,
  ListicleShowSharingHoverToolTip,
  ListicleShowSharingOnItemToolTip,
  ListicleUpvoteButtonIconToolTip,
  ListicleUpvoteButtonTextToolTip
} from 'components/break/tooltips/listicle-tool-tips';

import {FormattedMessage, IntlProvider} from 'react-intl';
import {enUSmessage} from 'i18n/en-US.js';
import {undeletedItems} from "../../../../../utils/DBUtils";

export default {
    name: "listicle",
    subSection: true,
    resource: true,
    hideIfResourceIsNoU: true,

    fields: [
        {
            type: 'contenteditable',
            name: 'headline',
            // Headline is only allowed if there is more than one step
            showField: (proxy) => (proxy.currentBaseResource.steps && proxy.currentBaseResource.steps.length > 1),
            linkedField: (formProxy) => ["title"],
            required: true,
            props: {
                labelKey: 'editbreak.steps.listicle.headline',
                helpContent:  <ListicleHeadlineToolTip/>,
                helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.listicle.headline'}/></IntlProvider>
            }
        },
        {
          type: 'image',
          name: 'headerImageId',
          props: {
            labelKey: 'editbreak.steps.listicle.header_image',
            imageType: 'stepHeaderImage',
            helpContent:  <ListicleHeaderImageToolTip/>,
            helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.listicle.header_image'}/></IntlProvider>
          }
        },
        {
            type: 'contenteditable',
            name: 'introCopy',
            required: false,
            props: {
              labelKey: 'editbreak.steps.listicle.intro_copy',
              helpContent:  <ListicleIntroToolTip/>,
              helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.listicle.intro_copy'}/></IntlProvider>,
              maxLength: 500,
              placeholderKey: 'editbreak.steps.listicle.intro_copy.placeholder',
              validationRules: [
                  { type: 'MarkupTextLimit',
                    params: {
                      limit: 500
                    }
                }
              ]
            }
        },
        {
            type: 'text',
            name: 'commentQuestion',
            showField: (proxy) => (proxy.currentBaseResource.showFBComments && proxy.currentBaseResource.sponsoredType !== 'sponsored' ),
            props: {
                labelKey: 'editbreak.steps.related_breaks.commentQuestion',
                helpContent: <FBCommentQuestionToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.breaks_steps.fbCommentQuestion'}/></IntlProvider>
            }
        },
        {
          name: 'displayFormat',
          type: 'radio',
          required: true,
          props: {
            labelKey: 'Display Format',
            options: [
              {
                value: 'list',
                textKey: 'List'
              },
              {
                value: 'slideshow',
                textKey: 'Slideshow'
              }
            ]
          }
        },
        {
          type: 'yesnoradio',
          name: 'defaultItemSharing',
          required: true,
          props: {
            labelKey: 'editbreak.steps.listicle.show_sharing_hover',
            helpContent:  <ListicleShowSharingHoverToolTip/>,
            helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.listicle.show_sharing_hover'}/></IntlProvider>
          }
        },
        {
          type: 'yesnoradio',
          name: 'showNumbers',
          required: true,
          props: {
            labelKey: 'editbreak.steps.listicle.show_numbers',
            helpContent:  <ListicleDefaultShowNumbersToolTip/>,
            helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.listicle.show_numbers'}/></IntlProvider>
          }
        },
        {
          conditionalSection: true,
          name: 'defaultVoting',
          required: true,
          props: {
            labelKey: 'editbreak.steps.listicle.has_voting',
            helpContent:  <ListicleDefaultAllowVotingToolTip/>,
            helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.listicle.has_voting'}/></IntlProvider>
          },
          fields: [
            {
                type: "text",
                name: "defaultUpvoteBtnText",
                required: true,
                props: {
                    labelKey: "editbreak.steps.listicle.default_upvote_text",
                    helpContent:  <ListicleDefaultUpvoteButtonTextToolTip/>,
                    helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.listicle.default_upvote_text'}/></IntlProvider>
                }
            },
            {
                type: "text",
                name: "defaultUpvoteBtnIcon",
                required: true,
                props: {
                    labelKey: "editbreak.steps.listicle.default_upvote_icon",
                    helpContent:  <ListicleDefaultUpvoteButtonIconToolTip/>,
                    helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.listicle.default_upvote_icon'}/></IntlProvider>
                }
            },
            {
                type: "text",
                name: "defaultDownvoteBtnText",
                required: true,
                props: {
                    labelKey: "editbreak.steps.listicle.default_downvote_text",
                    helpContent:  <ListicleDefaultDownvoteButtonTextToolTip/>,
                    helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.listicle.default_downvote_text'}/></IntlProvider>
                }
            },
            {
                type: "text",
                name: "defaultDownvoteBtnIcon",
                required: true,
                props: {
                    labelKey: "editbreak.steps.listicle.default_downvote_icon",
                    helpContent:  <ListicleDefaultDownvoteButtonIconToolTip/>,
                    helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.listicle.default_downvote_icon'}/></IntlProvider>
                }
            },
            {
              conditionalSection: true,
              name: 'hasVotingEndDate',
              required: true,
              props: {
                labelKey: 'editbreak.steps.listicle.has_voting_end_date'
              },
              fields: [
                {
                    type: "datetime",
                    name: "votingEndDateTime",
                    required: true,
                    props: {
                        labelKey: "editbreak.steps.listicle.voting_end_date"
                    }
                }
              ]
            },  // end conditional section for hasVotingEndDate
            {
                type: 'yesnoradio',
                name: "shouldSort",
                required: true,
                props: {
                    labelKey: 'editbreak.steps.listicle.should_sort'
                }
            },
          ]
        },  // end conditionalSection for has voting
        {
            name: 'items',
            subSection: true,
            resource: true,
            collection: true,
            sectionWrapper: IndexedSubSectionWrapper,
            deletable: true,
            canDelete: (formProxy) => {
              var listicle = formProxy.parentCurrentResource;
              return listicle.items && listicle.items.length > 1;
            },
            sortable: true,
            sortableName: "listicleItemsOrder",
            toggleSortLabelKey: 'editbreak.steps.listicle.item.reorder_toggle',
            resourceType: ResourceApi.Types.ListicleItem,

            props: {
                headerKey: 'editbreak.steps.listicle.item.header',
                getCustomSectionHeader: (item, sectionIndex) => {
                  return  item.subhead
                          && item.subhead.trim() !== "" ? "List Item " + (sectionIndex+1) + ": " + item.subhead : null;
                }
            },

            footerContent: createButtonSectionFactory(ResourceApi.Types.ListicleItem),
            fields: [
                {
                    type: 'yesnoradio',
                    name: 'showNumber',
                    required: true,
                    showField: (proxy) => (proxy.parentCurrentResource.showNumbers === true),
                    linkedField: (proxy) => {
                      var path = proxy.parentPath();
                      path.push("showNumbers");
                      return path;
                    },
                    props: {
                      labelKey: 'editbreak.steps.listicle.item.show_numbers',
                      helpContent:  <ListicleShowNumbersToolTip/>,
                      helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.listicle.item.show_numbers'}/></IntlProvider>
                    }
                },
                {
                    conditionalSection: true,
                    name: "hasVoting",
                    required: true,
                    linkedField: (proxy) => {
                      var path = proxy.parentPath();
                      path.push("defaultVoting");
                      return path;
                    },
                    props: {
                        labelKey: 'editbreak.steps.listicle.item.has_voting',
                        helpContent:  <ListicleAllowVotingToolTip/>,
                        helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.listicle.item.has_voting'}/></IntlProvider>
                    },

                    fields: [
                      {
                          type: "text",
                          name: "upvoteBtnText",
                          required: true,
                          linkedField: (proxy) => {
                            var path = proxy.parentPath();
                            path.push("defaultUpvoteBtnText");
                            return path;
                          },
                          props: {
                              labelKey: "editbreak.steps.listicle.item.default_upvote_text",
                              helpContent:  <ListicleUpvoteButtonTextToolTip/>,
                              helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.listicle.item.default_upvote_text'}/></IntlProvider>
                          }
                      },
                      {
                          type: "text",
                          name: "upvoteBtnIcon",
                          required: true,
                          linkedField: (proxy) => {
                            var path = proxy.parentPath();
                            path.push("defaultUpvoteBtnIcon");
                            return path;
                          },
                          props: {
                              labelKey: "editbreak.steps.listicle.item.default_upvote_icon",
                              helpContent:  <ListicleUpvoteButtonIconToolTip/>,
                              helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.listicle.item.default_upvote_icon'}/></IntlProvider>
                          }
                      },
                      {
                          type: "text",
                          name: "downvoteBtnText",
                          required: true,
                          linkedField: (proxy) => {
                            var path = proxy.parentPath();
                            path.push("defaultDownvoteBtnText");
                            return path;
                          },
                          props: {
                              labelKey: "editbreak.steps.listicle.item.default_downvote_text",
                              helpContent:  <ListicleDownvoteButtonTextToolTip/>,
                              helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.listicle.item.default_downvote_text'}/></IntlProvider>
                          }
                      },
                      {
                          type: "text",
                          name: "downvoteBtnIcon",
                          required: true,
                          linkedField: (proxy) => {
                            var path = proxy.parentPath();
                            path.push("defaultDownvoteBtnIcon");
                            return path;
                          },
                          props: {
                              labelKey: "editbreak.steps.listicle.item.default_downvote_icon",
                              helpContent:  <ListicleDefaultDownvoteButtonIconToolTip/>,
                              helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.listicle.item.default_downvote_icon'}/></IntlProvider>
                          }
                      }
                    ]
                },  // end conditional section for allow voting on item
                {
                    conditionalSection: true,
                    name: "hasVoteTracking",
                    required: true,
                    showField: (proxy) =>  (proxy.currentResource.hasVoting === true || (!isNoU(proxy.parentCurrentResource.defaultVoting) && proxy.parentCurrentResource.defaultVoting === true && isNoU(proxy.currentResource.hasVoting) ) ),
                    props: {
                        labelKey: 'editbreak.steps.listicle.item.has_vote_tracking',
                        helpContent:  <ListicleAddTrackingToVotingButtonsToolTip/>,
                        helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.listicle.item.has_vote_tracking'}/></IntlProvider>
                    },

                    fields: [
                      {
                          type: "text",
                          name: "upvoteTags",
                          required: true,
                          props: {
                              labelKey: "editbreak.steps.listicle.item.upvote_tags",
                              asList: true
                          }
                      },
                      {
                          type: "text",
                          name: "downvoteTags",
                          required: true,
                          props: {
                              labelKey: "editbreak.steps.listicle.item.downvote_tags",
                              asList: true
                          }
                      }
                    ]
                },  // end conditional section for allow voting on item
                {
                  type: 'yesnoradio',
                  name: 'sharing',
                  required: true,
                  showField: (proxy) => (proxy.parentCurrentResource.defaultItemSharing === true),
                  linkedField: (proxy) => {
                    var path = proxy.parentPath();
                    path.push("defaultItemSharing");
                    return path;
                  },
                  props: {
                    labelKey: 'editbreak.steps.listicle.item.has_sharing',
                    helpContent:  <ListicleShowSharingOnItemToolTip/>,
                    helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.listicle.item.has_sharing'}/></IntlProvider>
                  }
                },
                {
                  type: 'image',
                  name: 'shareImageId',
                  idFor: 'shareImage',
                  required: false,
                  showField: (proxy) => (proxy.parentCurrentResource.defaultItemSharing === true),
                  props: {
                    labelKey: 'editbreak.steps.listicle.item.sharing_image',
                    'imageType': 'socialShare',
                    helpContent:  <ListicleItemSocialShareImageToolTip/>,
                    helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.listicle.item.sharing_image'}/></IntlProvider>
                  }
                },
                {
                  type: 'dynamicContentRules',
                  name: 'dynamics',
                  required: true,
                  showField: proxy => Boolean(proxy.currentBaseResource.steps.find(step => step.type === 'PERSONALITY_QUIZ')),
                  props: {
                    labelKey: 'editbreak.steps.listicle.item.dynamics'
                  }
                },
                {
                  name: 'subhead',
                  type: 'contenteditable',
                  required: true,
                  props: {
                    labelKey: 'editbreak.steps.listicle.item.subhead',
                    helpContent:  <ListicleItemSubheadToolTip/>,
                    helpHeader: 'editbreak.steps.listicle.item.subhead',
                    placeholderKey: 'editbreak.steps.listicle.item.subhead.placeholder',
                    maxLength: 200,
                    validationRules: [
                        {
                          type: 'MarkupTextLimit',
                          params: {
                              limit: 200
                          }
                        }
                    ]
                  }
                },
                {
                  name: 'contents',
                  subSection: true,
                  resource: true,
                    collection: true,
                  sectionWrapper: IndexedSubSectionWrapper,
                  deletable: true,

                  props: {
                      getCustomSectionHeader: (content) => {
                        // TODO:
                        return content.type;
                      },
                  },

                    sortable: true,
                    sortableName: "listicleItemContentsOrder",
                    toggleSortLabelKey: 'editbreak.steps.listicle.item.content.reorder_toggle',
                    resourceType: ResourceApi.Types.ListicleContent,

                  footerContent: createButtonSectionFactory(
                    ResourceApi.Types.ListicleImage,
                      ResourceApi.Types.MenuContent,
                    ResourceApi.Types.ListicleBodyCopy,
                    ResourceApi.Types.ListicleBlockQuote,
                    ResourceApi.Types.ListicleEmbedContent,
                    ResourceApi.Types.ListicleLinkButton,
                    ResourceApi.Types.ListicleImageComparison,
                    ResourceApi.Types.ListicleAddToCalendar
                  ),

                  fields: [
                      //
                      // Menu Content
                      //
                      {
                          name: 'text',
                          type: 'contenteditable',
                          required: true,
                          showField: (proxy) => (proxy.currentResource.type === 'Menu'),
                          props: {
                              labelKey: 'editbreak.steps.article.menucontent.text',
                              // helpContent:  <ArticleSubheadToolTip/>,
                              // helpHeader: 'editbreak.steps.article.subhead'
                          }
                      },
                      {
                          name: 'items',
                          subSection: true,
                          resource: true,
                          collection: true,
                          sectionWrapper: IndexedSubSectionWrapper,
                          deletable: true,
                          canDelete: (formProxy) => {
                              const parent = formProxy.parentCurrentResource;
                              return parent.items && undeletedItems(parent.items).length > 2;
                          },
                          canCreate: (formProxy) => {
                              const parent = formProxy.parentCurrentResource;
                              return parent.items && undeletedItems(parent.items).length < 15;
                          },

                          props: {
                              getCustomSectionHeader: (content, sectionIndex) => {
                                  if ( content.label && content.label.trim() !== "") {
                                      return 'Menu Item ' + (sectionIndex+1) + ': ' + content.label;
                                  }

                                  return 'Menu Item';
                              },
                          },
                          footerContent: createButtonSectionFactory(
                              ResourceApi.Types.MenuContentItem
                          ),

                          sortable: true,
                          sortableName: "menuItemsOrder",
                          toggleSortLabelKey: 'editbreak.steps.article.content.reorder_toggle',
                          resourceType: ResourceApi.Types.MenuContentItem,

                          fields: [
                              {
                                  name: 'label',
                                  type: 'text',
                                  required: true,
                                  props: {
                                      labelKey: 'editbreak.steps.article.menucontent.item.label'
                                  }
                              },
                              {
                                  name: 'link',
                                  type: 'text',
                                  required: true,
                                  props: {
                                      labelKey: 'editbreak.steps.article.menucontent.item.link',
                                      starterValue: "https://",
                                      validationRules: [
                                          {
                                              type: 'HyperLinkFormat'
                                          }
                                      ]
                                  }
                              },
                              // {
                              //     name: 'trackingId',
                              //     type: 'text',
                              //     required: true,
                              //     props: {
                              //         labelKey: 'editbreak.steps.article.menucontent.item.trackingId',
                              //     }
                              // },
                              {
                                  name: 'imageId',
                                  type: 'image',
                                  idFor: 'image',
                                  props: {
                                      labelKey: 'editbreak.steps.article.menucontent.item.image',
                                      imageType: 'menuContentIcon',
                                  }
                              },
                          ]
                      },
                      //
                      // End Menu Content
                      //
                    {
                      name: 'imageType',
                      type: 'dropdown',
                      required: true,
                      showField: (proxy) => (proxy.currentResource.type === 'Image'),
                      props: {
                        labelKey: 'editbreak.steps.listicle.item.image.type',
                        options: [
                          {
                            value: 'CUSTOM',
                            textKey: 'editbreak.steps.listicle.item.image.type.custom'
                          },
                          {
                            value: 'HORIZONTAL',
                            textKey: 'editbreak.steps.listicle.item.image.type.horizontal'
                          },
                          {
                            value: 'VERTICAL',
                            textKey: 'editbreak.steps.listicle.item.image.type.vertical'
                          }
                        ]
                      }
                    },
                    {
                      name: 'scaling',
                      type: 'radio',
                      required: true,
                      showField: (proxy) => (proxy.currentResource.type === 'Image' && !isNoU(proxy.currentResource.imageType)),
                      props: {
                        labelKey: 'editbreak.steps.listicle.item.image.scaling',
                        helpContent:  <ListicleImageScalingToolTip/>,
                        helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.listicle.item.image.scaling'}/></IntlProvider>,
                        options: [
                          {
                            value: 100,
                            textKey: 'editbreak.steps.listicle.item.image.scaling.none'
                          },
                          {
                            value: 65,
                            textKey: 'editbreak.steps.listicle.item.image.scaling.65'
                          },
                          {
                            value: 75,
                            textKey: 'editbreak.steps.listicle.item.image.scaling.75'
                          }
                        ]
                      }
                    },
                    // TODO: Update imageType prop to be a method and not need multiple instances
                    {
                      name: 'imageId',
                      type: 'image',
                      idFor: 'image',
                      required: true,
                      showField: (proxy) => (proxy.currentResource.type === 'Image' && proxy.currentResource.imageType === 'CUSTOM'),
                      props: {
                        labelKey: 'editbreak.steps.listicle.item.image.image',
                        imageType: 'custom',
                        helpContent:  <ListicleImageToolTip/>,
                        helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.listicle.item.image.image'}/></IntlProvider>
                      }
                    },
                    {
                      name: 'imageId',
                      type: 'image',
                      idFor: 'image',
                      required: true,
                      showField: (proxy) => (proxy.currentResource.type === 'Image' && proxy.currentResource.imageType === 'HORIZONTAL'),
                      props: {
                        labelKey: 'editbreak.steps.listicle.item.image.image',
                        imageType: 'listicleHorizontal',
                        helpContent:  <ListicleImageToolTip/>,
                        helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.listicle.item.image.image'}/></IntlProvider>
                      }
                    },
                    {
                      name: 'imageId',
                      type: 'image',
                      idFor: 'image',
                      required: true,
                      showField: (proxy) => (proxy.currentResource.type === 'Image' && proxy.currentResource.imageType === 'VERTICAL'),
                      props: {
                        labelKey: 'editbreak.steps.listicle.item.image.image',
                        imageType: 'listicleVertical',
                        helpContent:  <ListicleImageToolTip/>,
                        helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.listicle.item.image.image'}/></IntlProvider>
                      }
                    },
                    {
                      name: 'blockQuote',
                      type: 'contenteditable',
                      required: true,
                      showField: (proxy) => (proxy.currentResource.type === 'BlockQuote'),
                      props: {
                        labelKey: 'editbreak.steps.listicle.item.block_quote.value',
                        placeholderKey: 'editbreak.steps.listicle.item.block_quote.value.placeholder',
                        helpContent:  <ListicleItemBlockquoteToolTip/>,
                        helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.listicle.item.block_quote.value'}/></IntlProvider>
                      }
                    },
                    {
                      name: 'blockQuoteSource',
                      type: 'contenteditable',
                      required: false,
                      showField: (proxy) => (proxy.currentResource.type === 'BlockQuote'),
                      props: {
                        labelKey: 'editbreak.steps.listicle.item.block_quote_source.value',
                        placeholderKey: 'editbreak.steps.listicle.item.block_quote_source.value.placeholder'
                      }
                    },
                    {
                      name: 'bodyCopy',
                      type: 'contenteditable',
                      required: true,
                      showField: (proxy) => (proxy.currentResource.type === 'BodyCopy'),
                      props: {
                        labelKey: 'editbreak.steps.listicle.item.body_copy.value',
                        placeholderKey: 'editbreak.steps.listicle.item.body_copy.value.placeholder',
                        helpContent:  <ListicleItemBodyCopyToolTip/>,
                        helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.listicle.item.body_copy.value'}/></IntlProvider>
                      }
                    },
                    {
                      name: 'content',
                      type: 'contenteditable',
                      required: true,
                      showField: (proxy) => (proxy.currentResource.type === 'OldBodyCopy'),
                      props: {
                        labelKey: 'editbreak.steps.listicle.item.old_body_copy.value'
                      }
                    },
                    {
                      name: 'embedCode',
                      type: 'textarea',
                      required: true,
                      showField: (proxy) => (proxy.currentResource.type === 'EmbedCode'),
                      props: {
                        labelKey: 'editbreak.steps.listicle.item.embed_code.value',
                        placeholderKey: 'editbreak.steps.listicle.item.embed_code.value.placeholder',
                        helpContent:  <ListicleEmbedToolTip/>,
                        helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.listicle.item.embed_code.value'}/></IntlProvider>
                      }
                    },
                    {
                      name: 'buttonText',
                      type: 'text',
                      required: true,
                      showField: (proxy) => (proxy.currentResource.type === 'Button'),
                      props: {
                        labelKey: 'editbreak.steps.listicle.item.button.text'
                      }
                    },
                    {
                      name: 'url',
                      type: 'text',
                      required: true,
                      showField: (proxy) => (proxy.currentResource.type === 'Button'),
                      props: {
                        labelKey: 'editbreak.steps.listicle.item.button.url'
                      }
                    },
                    {
                      name: 'textColor',
                      type: 'color',
                      required: false,
                      showField: (proxy) => (proxy.currentResource.type === 'Button'),
                      props: {
                        labelKey: 'editbreak.steps.listicle.item.button.text_color'
                      }
                    },
                    {
                      name: 'bgColor',
                      type: 'color',
                      required: false,
                      showField: (proxy) => (proxy.currentResource.type === 'Button'),
                      props: {
                        labelKey: 'editbreak.steps.listicle.item.button.bg_color'
                      }
                    },
                    {
                      name: 'leftImageId',
                      type: 'image',
                      idFor: 'leftImage',
                      required: true,
                      showField: (proxy) => (proxy.currentResource.type === 'ImageComparison'),
                      props: {
                        labelKey: 'editbreak.steps.listicle.item.image_comparison.left_image',
                        imageType: 'listicleImageComparison'
                      }
                    },
                    {
                      name: 'rightImageId',
                      type: 'image',
                      idFor: 'rightImage',
                      required: true,
                      showField: (proxy) => (proxy.currentResource.type === 'ImageComparison'),
                      props: {
                        labelKey: 'editbreak.steps.listicle.item.image_comparison.right_image',
                        imageType: 'listicleImageComparison'
                      }
                    },
                    {
                      name: 'startPosition',
                      type: 'dropdown',
                      required: true,
                      showField: (proxy) => (proxy.currentResource.type === 'ImageComparison'),
                      props: {
                        labelKey: 'editbreak.steps.listicle.item.image_comparison.start_position',
                        options: [
                          {
                            value: 'LEFT',
                            textKey: 'editbreak.steps.listicle.item.image_comparison.start_position.left'
                          },
                          {
                            value: 'CENTER',
                            textKey: 'editbreak.steps.listicle.item.image_comparison.start_position.center'
                          },
                          {
                            value: 'RIGHT',
                            textKey: 'editbreak.steps.listicle.item.image_comparison.start_position.right'
                          }
                        ]
                      }
                    },
                    {
                      name: 'buttonText',
                      type: 'text',
                      required: false,
                      showField: (proxy) => (proxy.currentResource.type === 'AddToCalendar'),
                      props: {
                        labelKey: 'editbreak.steps.listicle.item.add_to_calendar.btn_text'
                      }
                    },
                    {
                      name: 'position',
                      type: 'dropdown',
                      required: true,
                      showField: (proxy) => (proxy.currentResource.type === 'AddToCalendar'),
                      props: {
                        labelKey: 'editbreak.steps.listicle.item.add_to_calendar.position',
                        options: [
                          {value: 'LEFT', text: 'Left' },
                          {value: 'CENTER', text: 'Center' },
                          {value: 'RIGHT', text: 'Right' }
                        ]
                      }
                    },
                    {
                      name: 'event.title',
                      type: 'text',
                      required: true,
                      showField: (proxy) => (proxy.currentResource.type === 'AddToCalendar'),
                      props: {
                        labelKey: 'editbreak.steps.listicle.item.add_to_calendar.event.title'
                      }
                    },
                    {
                      name: 'event.desc',
                      type: 'textarea',
                      required: true,
                      showField: (proxy) => (proxy.currentResource.type === 'AddToCalendar'),
                      props: {
                        labelKey: 'editbreak.steps.listicle.item.add_to_calendar.event.desc'
                      }
                    },
                    {
                      name: 'event.location',
                      type: 'text',
                      required: true,
                      showField: (proxy) => (proxy.currentResource.type === 'AddToCalendar'),
                      props: {
                        labelKey: 'editbreak.steps.listicle.item.add_to_calendar.event.location'
                      }
                    },
                    {
                      name: 'event.startTime',
                      type: 'datetime',
                      required: true,
                      showField: (proxy) => (proxy.currentResource.type === 'AddToCalendar'),
                      props: {
                        labelKey: 'editbreak.steps.listicle.item.add_to_calendar.event.starttime'
                      }
                    },
                    {
                      name: 'event.endTime',
                      type: 'datetime',
                      required: true,
                      showField: (proxy) => (proxy.currentResource.type === 'AddToCalendar'),
                      props: {
                        labelKey: 'editbreak.steps.listicle.item.add_to_calendar.event.endtime'
                      }
                    },
                    {
                      name: 'event.timezone',
                      type: 'dropdown',
                      required: true,
                      showField: (proxy) => (proxy.currentResource.type === 'AddToCalendar'),
                      props: {
                        labelKey: 'editbreak.steps.listicle.item.add_to_calendar.event.timezone',
                        options: [
                          {value: 'America/New_York', textKey: 'timezones.eastern' },
                          {value: 'America/Chicago', textKey: 'timezones.central' },
                          {value: 'America/Denver', textKey: 'timezones.mountain' },
                          {value: 'America/Los_Angeles', textKey: 'timezones.pacific' },
                          {value: 'Europe/London', textKey: 'timezones.london' }
                        ]
                      }
                    },
                    {
                        name: 'layoutRow',
                        type: 'dropdown',
                        required: true,
                        showField: true,
                        props: {
                          labelKey: 'editbreak.steps.listicle.item.layout.layoutRow',
                          options: [
                            {value: 'TOP', text: 'Top' },
                            {value: 'MIDDLE', text: 'Middle' },
                            {value: 'BOTTOM', text: 'Bottom' },
                          ]
                        }
                    },
                    {
                        name: 'layoutColumn',
                        type: 'dropdown',
                        required: false,
                        showField: (proxy) => (proxy.currentResource.layoutRow === 'MIDDLE'),
                        props: {
                          labelKey: 'editbreak.steps.listicle.item.layout.layoutColumn',
                          options: [
                            {value: 'LEFT', text: 'Left' },
                            {value: 'RIGHT', text: 'Right' },
                          ]
                        }
                      },

                    ]
                } // end entry/content array

            ]
          } // end items array
    ]
}



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/steps/listicle.js